module.exports = __webpack_public_path__ + "staticVue/img/pwd-icon.ca9f4554.png";